/*
 *  I01EVACONSSYSTECS2I18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-09 11:48:53 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I01EVACONSSYSTECS2_SECTION_0_TITLE: "Calculez une production d'eau chaude dans un batiment tertiaire",
  I01EVACONSSYSTECS2_SECTION_0BIS_TITLE: 'Type de batiment et usage ECS',
  I01EVACONSSYSTECS2_SECTION_1_TITLE: 'Détails des équipements sanitaires',
  I01EVACONSSYSTECS2_in_typeCalcul: '', //do not delete,required. auto generated code for empty title for segment
  I01EVACONSSYSTECS2_in_typeCalcul_0: 'Stockage ECS',
  I01EVACONSSYSTECS2_in_typeCalcul_1: 'Stockage primaire',
  I01EVACONSSYSTECS2_in_coeffMajor: 'Coefficient de simultanéité',
  I01EVACONSSYSTECS2_in_pourcentLpointe: '% L/jours pointe',
  I01EVACONSSYSTECS2_in_dureeHPointe: 'Durée pointe ',
  I01EVACONSSYSTECS2_in_tempsEntrePointe: 'Temps entre pointe ',
  I01EVACONSSYSTECS2_in_content: 'L/j par',
  I01EVACONSSYSTECS2_in_content_mail: 'Consommation unitaire par jour',
  I01EVACONSSYSTECS2_SECTION_1_TITLEBIS: 'Indicateurs de puisage',
  I01EVACONSSYSTECS2_in_evier: 'Evier',
  I01EVACONSSYSTECS2_in_lavabo: 'Lavabo',
  I01EVACONSSYSTECS2_in_bidet: 'Bidet',
  I01EVACONSSYSTECS2_in_baignoire: 'Baignoire',
  I01EVACONSSYSTECS2_in_douche: 'Douche',
  I01EVACONSSYSTECS2_in_robinetdemi: 'Robinet 1/2',
  I01EVACONSSYSTECS2_in_robinetquart: 'Robinet 3/4',
  I01EVACONSSYSTECS2_in_lavemain: 'Lave mains',
  I01EVACONSSYSTECS2_in_baclaver: 'Bac à laver',
  I01EVACONSSYSTECS2_in_linge: 'Machine à laver le linge',
  I01EVACONSSYSTECS2_in_vaiselle: 'Machine à laver la vaisselle',
  I01EVACONSSYSTECS2_res_S: 'Simultanéité',
  I01EVACONSSYSTECS2_res_debit10mn: 'Débit 10 mn',
  I01EVACONSSYSTECS2_res_debitMinute: 'Débit minute',
  I01EVACONSSYSTECS2_res_debitSeconde: 'Débit seconde',
  I01EVACONSSYSTECS2_SECTION_2_TITLE: 'Typologie et besoin',
  I01EVACONSSYSTECS2_SECTION_2_TITLE2: "Puissance instantanée de l'échangeur",
  I01EVACONSSYSTECS2_in_tempFroide: 'Température eau froide',
  I01EVACONSSYSTECS2_in_tempChaude: 'Température eau chaude',
  I01EVACONSSYSTECS2_in_departPrimaire: 'Température de stockage',
  I01EVACONSSYSTECS2_res_consommationJournaliere: 'Consommation journalière',
  I01EVACONSSYSTECS2_res_puissanceNecessaire: 'Puissance échangeur instantanée',
  I01EVACONSSYSTECS2_SECTION_3_TITLE: 'Typologie et besoin',
  I01EVACONSSYSTECS2_in_retourPrimaire: 'Retour primaire',
  I01EVACONSSYSTECS2_SECTION_4_TITLE: 'Type de couple ECS',
  I01EVACONSSYSTECS2_res_modeCoupleECS: 'Mode',
  I01EVACONSSYSTECS2_in_volumeTypeECS: 'Volume stockage',
  I01EVACONSSYSTECS2_res_puissanceTypeECS: 'Puissance échangeur',
  I01EVACONSSYSTECS2_res_puissanceTypeECS2: 'Puissance du générateur',
  I01EVACONSSYSTECS2_in_stockagePrimaire: 'Stockage ECS',
  I01EVACONSSYSTECS2_in_stockagePrimaire2: 'Stockage primaire',
  I01EVACONSSYSTECS2_couple_inst: 'Couple Instantanée',
  I01EVACONSSYSTECS2_couple_semi: 'Couple Semi-instantané',
  I01EVACONSSYSTECS2_couple_semiacc: 'Couple Semi-accumulé'
}
